/* import __COLOCATED_TEMPLATE__ from './default-table-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();